import './PlansAreaIndicatorsImpact.css';
import React, { useEffect, useState } from 'react';
import ElementsCarousel from '../../../b2b-common/ElementsCarousel';
import { generateClassName } from '../../../b2b-common/helpers';
import usePlansImpact from '../../hooks/usePlansImpact';
import LevelNImageCard from '../LevelNImageCard';
import isEqual from 'lodash/isEqual';

const PlansAreaIndicatorsImpact = ({
    frameworkSuite, frameworkId, plansUUIDs,
    showStatus = false, showTrend = false, showProgress = false,
    onSelectedLevelN, className = null
}) => { 
    const { plansImpact, isSearching } = usePlansImpact(frameworkSuite, frameworkId, plansUUIDs);
    const [currentSelectedLevelN, setCurrentSelectedLevelN] = useState(null);

    useEffect(() => {
        if (!isSearching && plansImpact && plansImpact.length > 0 && currentSelectedLevelN === null) {
            handleSelectedLevelN(plansImpact[0].dtoReference.theOne);
        }
    }, [plansImpact, isSearching, currentSelectedLevelN]);

    if (!plansImpact || isSearching) return null;

    const handleSelectedLevelN = (levelN) => {
        // console.log('Selected LevelN:', levelN);
        setCurrentSelectedLevelN(levelN.levelN_ItemId);
        const areaIndicators = plansImpact.find(impactAnalysisItem =>
            impactAnalysisItem.dtoReference.theOne.levelN_ItemId === levelN.levelN_ItemId)
            .indicatorsConsidered;
        onSelectedLevelN && onSelectedLevelN(areaIndicators);
    };

    return (
        <div className={generateClassName('plans-impact-areaindicators','-container',className)}>
            {isSearching && <p>Searching...</p>}
            {!isSearching && plansImpact &&
                <ElementsCarousel
                    elements={plansImpact ? plansImpact.map(impactAnalysisItem => {
                        const levelN = impactAnalysisItem.dtoReference.theOne;
                        return <LevelNImageCard
                            key={levelN.levelN_ItemId}
                            frameworkSuite={frameworkSuite}
                            frameworkId={frameworkId}
                            levelN={levelN}
                            progress={impactAnalysisItem.progress}
                            showProgress={showProgress}
                            status={impactAnalysisItem.status}
                            showStatus={showStatus}
                            trend={impactAnalysisItem.trend}
                            showTrend={showTrend}
                            allowsSelection={true}
                            selectedLevelNs={[currentSelectedLevelN]}
                            onClick={handleSelectedLevelN}
                            className={'plans-impact-areaindicators-card theme-resalt-selected-01'}
                        />;
                    }) : []}
                    className={'plans-impact-areaindicators-carousel'}
                />
            }
        </div>
    );
}

const areEqual = (prevProps, nextProps) => {
    return isEqual(prevProps, nextProps);
};

export default React.memo(PlansAreaIndicatorsImpact, areEqual);